module.exports = __webpack_public_path__ + "assets/695ce8f56a4adbed41a63463bbdf3676.png";